export const environment = {
  name: 'acceptance',
  apiUrl: 'https://betaalverzoek-api.staging.knab.nl/api',
  shouldTrimPublicId: true,
  launchMobileConsole: false,
  otlpTracesUrl: 'https://betaalverzoek-api.staging.knab.nl/otlp/v1/traces',
  otlpMetricsUrl: 'https://betaalverzoek-api.staging.knab.nl/otlp/v1/metrics',
  otlpLogsUrl: 'https://betaalverzoek-api.staging.knab.nl/otlp/v1/logs'
};
